/** Supported dimension units */
export type DimensionUnit = 'Inches' | 'Centimeters';

export const DIMENSION_UNIT_INCHES: DimensionUnit = 'Inches';
export const DIMENSION_UNIT_CENTIMETERS: DimensionUnit = 'Centimeters';

// Can be returned by BE. Should only be used as a check to fall back to something else.
export const DIMENSION_UNIT_UNKNOWN = 'Unknown';

/** Seller settings API values (singular form) */
export const DIMENSION_SETTING_INCH = 'Inch';
export const DIMENSION_SETTING_CENTIMETER = 'Centimeter';

/** Package dimensions with unit */
export type Dimensions = {
  length: number;
  width: number;
  height: number;
  unit: DimensionUnit;
};
